import React from 'react';

export default function PageLoading(){
    return <div className="wrap wrap--high wrap--loading"></div>
}